import { InvoiceBillingStage } from '@features/invoices/enums/invoiceBillingStage'

export const quoteBillingStageToTranslationKey: Record<InvoiceBillingStage, string> = {
  [InvoiceBillingStage.Deposit]: 'quotes.view.sidebar.timeline.status.deposit_invoice_created',
  [InvoiceBillingStage.Final]: 'quotes.view.sidebar.timeline.status.final_invoice_created',
}
